import {
  createRouter,
  createWebHistory,
  createMemoryHistory,
} from "vue-router";

import { useMenuStore, usePageStore, usePreferencesStore } from "../stores";
import { isLoading, mobileNavOpen } from "../services/helpers";

const PageView = () => import("../views/PageView.vue");

const router = createRouter({
  history: import.meta.env.SSR
    ? createMemoryHistory(import.meta.env.BASE_URL)
    : createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: "/", name: "HOME", component: PageView },
    { path: "/en", name: "ENGLISH HOME", component: PageView },

    { path: "/en/404", name: "ENGLISH 404", component: () => import("../views/NotFoundView.vue") },

    {
      path: "/en/:pageName",
      component: PageView,
      children: [
        {
          path: ":subPageName",
          component: PageView,
          children: [
            {
              path: ":subSubPageName",
              component: PageView,
            },
          ],
        },
      ],
    },
    {
      path: "/:pageName",
      component: PageView,
      children: [
        {
          path: ":subPageName",
          component: PageView,
          children: [
            {
              path: ":subSubPageName",
              component: PageView,
            },
          ],
        },
      ],
    },

    { path: "/404", name: "404", component: () => import("../views/NotFoundView.vue") },
  ],
});

router.beforeEach(async (to, from, next) => {
  // SSR: keine Client-Logik
  if (import.meta.env.SSR) {
    next();
    return;
  }

  isLoading.value = true;
  mobileNavOpen.value = false;

  const menuStore = useMenuStore();
  const pageStore = usePageStore();
  const preferenceStore = usePreferencesStore();

  const urlIsEnglish = to.path === "/en" || to.path.startsWith("/en/");
  const lang = preferenceStore.language;

  /* ----------------------------------------
   * 1️⃣ Homepage immer erlauben
   * ---------------------------------------- */
  if (to.path === "/" || to.path === "/en") {
    await pageStore.updatePage(7); // Homepage-ID
    next();
    return;
  }

  /* ----------------------------------------
   * 2️⃣ Sprache synchronisieren
   * ---------------------------------------- */
  if (lang === "de-DE" && urlIsEnglish) {
    await preferenceStore.updateLanguage("en-US");
  }
  if (lang === "en-US" && !urlIsEnglish) {
    await preferenceStore.updateLanguage("de-DE");
  }

  /* ----------------------------------------
   * 3️⃣ 🔑 Navigation sicherstellen (WICHTIG!)
   * ---------------------------------------- */
  if (menuStore.main_menu.length === 0) {
    try {
      await menuStore.updateAllNavigations(true); // force
    } catch (e) {
      console.error("Failed to load navigation before routing", e);
    }
  }

  /* ----------------------------------------
   * 4️⃣ Jetzt erst prüfen
   * ---------------------------------------- */
  const navigationElement = menuStore.getMenuItemByPath(to.fullPath);

  if (
    !navigationElement &&
    to.name !== "404" &&
    to.name !== "ENGLISH 404" &&
    !to.query.s
  ) {
    next(urlIsEnglish ? { name: "ENGLISH 404" } : { name: "404" });
    return;
  }

  /* ----------------------------------------
   * 5️⃣ Seite laden
   * ---------------------------------------- */
  try {
    await pageStore.updatePage(navigationElement?.page?.key);
  } catch (error) {
    console.error("Failed to load page in router:", error);
  }

  next();
});


export default router;
